import React from 'react';
import portrait from '../../assets/images/3-data-art/artist/yifang2.JPG';

// The page's opening: the artist's portrait on the left, the black page on the right, a thin 8 x 4 grid over both, and
// the page's first theme set as type: "PHILOSOPHICAL" in light spaced caps and "reflection" as heavy letters that drop
// through the grid's rows and across the split (after the "beyond" poster of Exp23). The letters invert over the photo.
const LETTERS: { ch: string, y: number, clip?: string }[] = [
  { ch: 'r', y: 0 },
  { ch: 'e', y: 0.42 },
  { ch: 'f', y: -0.08, clip: 'inset(16% 0 0 0)' },
  { ch: 'l', y: 0.5 },
  { ch: 'e', y: 0.12 },
  { ch: 'c', y: 0.68, clip: 'inset(0 0 34% 0)' },
  { ch: 't', y: 0.26 },
  { ch: 'i', y: -0.04 },
  { ch: 'o', y: 0.58, clip: 'inset(0 0 42% 0)' },
  { ch: 'n', y: 0.2 },
];

const NAV = [
  { href: '#philosophical-reflection', label: 'Reflection' },
  { href: '#protest-and-critique', label: 'Critique' },
  { href: '#humanity-appreciation', label: 'Humanity' },
  { href: '#artist-collaborator', label: 'Collaborators' },
];

const DataArtHero: React.FC = () => (
  <section className='da-hero' aria-label='Data-driven art'>
    <div className='da-hero-photo'><img src={portrait} alt='Yifang Wang in front of a steel sculpture' /></div>
    <div className='da-hero-grid' aria-hidden='true' />

    <h1 className='da-hero-title'>Data-driven Art</h1>
    <nav className='da-hero-nav'>
      {NAV.map(n => <a key={n.href} href={n.href}>{n.label}</a>)}
    </nav>

    <p className='da-hero-kicker'>Philosophical</p>
    <a className='da-hero-word' href='#philosophical-reflection' aria-label='Philosophical reflection'>
      {LETTERS.map((l, i) => (
        <span key={i} aria-hidden='true' style={{ transform: `translateY(${l.y}em)`, clipPath: l.clip }}>{l.ch}</span>
      ))}
    </a>

    <p className='da-hero-caption'>Big data, AI, and visualization serve{' '}<br />to foster reflection rather than action.</p>
  </section>
);

export default DataArtHero;
